import { render, staticRenderFns } from "./admin-multi-org-employee-add-dialog.vue?vue&type=template&id=9ddff1a6&scoped=true&"
import script from "./admin-multi-org-employee-add-dialog.vue?vue&type=script&lang=js&"
export * from "./admin-multi-org-employee-add-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddff1a6",
  null
  
)

export default component.exports